import { createFileRoute } from "@tanstack/react-router";
import { PageHero } from "@/components/site/PageHero";
import { MapPin, Clock, ArrowRight, Coffee, Heart, GraduationCap, Rocket } from "lucide-react";

export const Route = createFileRoute("/careers")({
  head: () => ({
    meta: [
      { title: "Careers — Join BigBrandBooster" },
      { name: "description", content: "Build a career at BigBrandBooster. Open roles in strategy, performance media, content, design and engineering." },
      { property: "og:title", content: "Careers — BigBrandBooster" },
      { property: "og:description", content: "Open roles across strategy, media, content and engineering." },
    ],
    links: [{ rel: "canonical", href: "/careers" }],
  }),
  component: CareersPage,
});

const roles = [
  // { title: "Senior Performance Strategist", team: "Paid Media", location: "Noida, IN", type: "Full-time" },
  { title: "SEO Lead", team: "Organic Growth", location: "Remote", type: "Full-time" },
  // { title: "Creative Director", team: "Brand & Creative", location: "Bengaluru, IN", type: "Full-time" },
  // { title: "Senior Frontend Engineer", team: "Web & Product", location: "Remote", type: "Full-time" },
  // { title: "Content Strategist", team: "Editorial", location: "Mumbai, IN", type: "Full-time" },
  // { title: "Analytics Manager", team: "Data & Insights", location: "Noida, IN", type: "Full-time" },
];

const perks = [
  { icon: Heart, title: "Health & wellbeing", desc: "Comprehensive health cover for you and your family." },
  { icon: GraduationCap, title: "Learning budget", desc: "Annual stipend for courses, books and conferences." },
  { icon: Coffee, title: "Flexible work", desc: "Hybrid by default, remote-friendly across teams." },
  { icon: Rocket, title: "Career velocity", desc: "Senior-led mentorship and clear growth pathways." },
];

function CareersPage() {
  return (
    <>
      <PageHero
        eyebrow="Careers"
         gradientClass="bg-services-gradient"
        title={<>Build a career where <span className="text-accent">craft and impact</span> meet.</>}
        description="We're hiring strategists, creatives and engineers who care deeply about doing the work — and seeing it work."
      />

      <section className="bg-secondary/40 py-20">
        <div className="container-page">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink">Why BigBrandBooster</h2>
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {perks.map((p) => (
              <div key={p.title} className="rounded-2xl bg-card border border-border p-6">
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-xl bg-primary-gradient text-primary-foreground"><p.icon className="h-5 w-5" /></span>
                <h3 className="mt-4 font-display text-lg font-semibold text-ink">{p.title}</h3>
                <p className="mt-1 text-sm text-muted-foreground">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="container-page py-24">
        <div className="flex items-end justify-between mb-10">
          <h2 className="font-display text-4xl md:text-5xl font-bold text-ink">Open roles</h2>
          <p className="text-muted-foreground hidden md:block">{roles.length} positions open</p>
        </div>
        <div className="divide-y divide-border rounded-3xl border border-border bg-card">
          {roles.map((r) => (
            <a key={r.title} href="#apply" className="group flex flex-col md:flex-row md:items-center justify-between gap-4 p-6 hover:bg-secondary/50 transition first:rounded-t-3xl last:rounded-b-3xl">
              <div>
                <h3 className="font-display text-xl font-semibold text-ink group-hover:text-primary">{r.title}</h3>
                <p className="text-sm text-muted-foreground mt-1">{r.team}</p>
              </div>
              <div className="flex flex-wrap items-center gap-5 text-sm text-foreground/70">
                <span className="inline-flex items-center gap-1.5"><MapPin className="h-4 w-4" /> {r.location}</span>
                <span className="inline-flex items-center gap-1.5"><Clock className="h-4 w-4" /> {r.type}</span>
                <span className="inline-flex items-center gap-1.5 font-semibold text-primary">Apply <ArrowRight className="h-4 w-4 transition group-hover:translate-x-0.5" /></span>
              </div>
            </a>
          ))}
        </div>
      </section>
    </>
  );
}
